import React from 'react'
import styled from '@emotion/styled'

export const H2 = styled.h2`
`

export default H2